import { render, staticRenderFns } from "./VisitedIndex.vue?vue&type=template&id=3486897f&lang=pug&"
import script from "./VisitedIndex.vue?vue&type=script&lang=js&"
export * from "./VisitedIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports